import React from 'react';
import { Carousel } from 'antd-mobile';

import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { checkIfLogin } from '@utils/global';
import { appMethod as app, globalData } from '@utils/app';
import { pageInstance } from '@utils/page';

import './UserCenterHeadCustomComponent.less';

export default class UserCenterHeadCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }
  
  init = (compindex, pageInstance) => {
    let url = '/index.php?r=appVipCard/getUserAccountSurvey';
    app.sendRequest({
      url: url,
      success: function(res) {
        let userData = {};
        res.data.buyVip = false;
        res.data.balance = parseInt(res.data.balance);
        for (let item of res.data.all_vip_card) {
          if (item.condition_type == 2) {
            res.data.buyVip = true; //是否显示购买会员按钮
          }
        }
        userData['eles[' + compindex + '].userData'] = res.data;
        pageInstance.setData(userData);
      }
    })
  }

  showVipCardInfo = (e) => {
    let data = {};
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let show = e.currentTarget.dataset.show == 'true'; // 跟小程序略有不同
    let compData = pageInstance.state.eles[compindex];
    let height = parseInt(compData['customFeature']['topSectionStyle']['topHeight']);
    if (!show) {
      data['eles[' + compindex + '].customFeature.topSectionStyle.topHeight'] = ((height >= 270 ? height : 270) + 150)/100 + 'rem';
    } else {
      data['eles[' + compindex + '].customFeature.topSectionStyle.topHeight'] = (height*100 - 150) / 100 + 'rem';
    }
    data['eles[' + compindex + '].customFeature.showInfo'] = !show;
    pageInstance.setData(data);
    e.stopPropagation(); // 阻止冒泡
  }

  userCenterTurnToPage = (e) => {
    app.userCenterTurnToPage(e)
    e.stopPropagation(); // 阻止冒泡
  }

  vipCardTurnToPage = (e) => {
    e.stopPropagation();
    const {
      type,
      id,
      isturnto,
      needcollectinfo
    } = e.currentTarget.dataset;
    const chainParam = '';
    if (type == 'get-vip') {
      app.turnToPage('userCenter', {
        is_member: 1,
        franchisee: globalData.chainAppId || ''
      });
    } else if (type == 'buy-vip') {
      app.turnToPage('vipBenefits', {
        is_paid_card: 1
      })
    } else if (type == 'renewal-vip') {
      app.turnToPage('vipBenefits', {
        is_paid_card: 1,
        id: id,
      });
    } else if (type == 'ordinary-vip') {
      app.turnToPage('vipBenefits', {
        id
      });
    } else if (type == 'average-user') {
      if (isturnto == 'true') {
        if (needcollectinfo == 1) {
          app.turnToPage('userCenter' + chainParam, {
            is_member: 1,
            franchisee: globalData.chainAppId || ''
          })
        } else {
          app.turnToPage('vipBenefits');
        }
      }
    } else if (type == 'differential-mall') {
      app.turnToPage('/dMWebView');
    }
  }

  showQRRemark = (e) => {
    app.showQRRemark(e);
    e.stopPropagation(); // 阻止冒泡
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    const userData = data.userData;              // 用户数据
    /**
     * 页面上的数据
     */
    const userInfo = pageInstance.state.userInfo || {};   // 用户信息
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    /**
     * 组件内容处理
     */   
    let content = data.content;
    /**
     * 返回组件
     */
    return (
      <div className="custom-component user-center-head" style={styleObj}>
        {/* 会员：普通版 */}
        {
          customFeature.member == 1 && (
            <React.Fragment>
              {
                customFeature['personal-mode'] == 1 && (
                  <div className="show-view" onClick={this.userCenterTurnToPage} data-router="userCenter"
                    style={{
                      height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                      backgroundColor: customFeature.topSectionStyle['background-color'],
                      backgroundImage: customFeature.topSectionStyle['background-image'],
                      opacity: customFeature.topSectionStyle['opacity'] || 1,
                      backgroundSize: '100% 100%',
                    }}
                  >
                    <label className="empty-span"></label>
                    <img className="cover-thumb" style={{
                      width: customFeature.topSectionStyle.coverHeight,
                      height: customFeature.topSectionStyle.coverHeight,
                    }} src={userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt=""/>
                    <label className="nickname" style={{
                      color: customFeature.topSectionStyle.color,
                      fontSize: customFeature.topSectionStyle['font-size'],
                      fontStyle: customFeature.topSectionStyle['font-style'],
                      textDecoration: customFeature.topSectionStyle['text-decoration'],
                      fontWeight: customFeature.topSectionStyle['font-weight'],
                      marginLeft: '.40rem',
                    }}>{ userInfo.nickname || '用户名'}</label>
                    <label className="ico-moon icon-rightarrow"></label>
                  </div>
                )
              }
              {
                customFeature['personal-mode'] == 2 && (
                  <div className="show-view" onClick={this.userCenterTurnToPage} data-router="userCenter"
                    style={{
                      textAlign: 'center',
                      height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                      backgroundColor: customFeature.topSectionStyle['background-color'],
                      backgroundImage: customFeature.topSectionStyle['background-image'],
                      opacity: customFeature.topSectionStyle['opacity'] || 1,
                      backgroundSize: '100% 100%',
                    }}>
                    <label className="empty-span"></label>
                    <div style={{
                      display: 'inline-block',
                      verticalAlign: 'middle',
                    }}>
                      <img className="cover-thumb" style={{
                        width: customFeature.topSectionStyle.coverHeight,
                        height: customFeature.topSectionStyle.coverHeight,
                      }} src={userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt=""/>
                      <label className="nickname" style={{
                        color: customFeature.topSectionStyle.color,
                        fontSize: customFeature.topSectionStyle['font-size'],
                        fontStyle: customFeature.topSectionStyle['font-style'],
                        textDecoration: customFeature.topSectionStyle['text-decoration'],
                        fontWeight: customFeature.topSectionStyle['font-weight'],
                      }}>{ userInfo.nickname || '用户名'}</label>
                    </div>
                    <div className="empty-span"></div>
                  </div>
                )
              }
              {
                customFeature['personal-mode'] == 3 && (
                  <div className="personal-mode-0" onClick={this.userCenterTurnToPage} data-router="userCenter"
                    style={{
                      textAlign: 'center',
                      height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                      backgroundColor: customFeature.topSectionStyle['background-color'],
                      backgroundImage: customFeature.topSectionStyle['background-image'],
                      opacity: customFeature.topSectionStyle['opacity'] || 1,
                      backgroundSize: '100% 100%',
                    }}>
                    <label className="empty-span"></label>
                    <label className="nickname" style={{
                        color: customFeature.topSectionStyle.color,
                        fontSize: customFeature.topSectionStyle['font-size'],
                        fontStyle: customFeature.topSectionStyle['font-style'],
                        textDecoration: customFeature.topSectionStyle['text-decoration'],
                        fontWeight: customFeature.topSectionStyle['font-weight'],
                      }}>{ userInfo.nickname || '用户名'}</label>
                    <label className="ico-moon icon-rightarrow"></label>
                    <img className="cover-thumb" style={{
                      width: customFeature.topSectionStyle.coverHeight,
                      height: customFeature.topSectionStyle.coverHeight,
                    }} src={userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt=""/>
                  </div>
                )
              }
            </React.Fragment>
          )
        }
        {/* 会员：会员版 */}
        {
          userData && customFeature.member == 2 && (
            <React.Fragment>
              {
                customFeature['senior-mode'] == 1 && (
                  <div style={{
                    paddingBottom: !userData.user_vip_card || !userData.user_paid_vip_card || userData.need_collect_info == 1 ? '.30rem' : 0
                  }}>
                    <div className="show-view-all" style={{
                      paddingBottom: !userData.user_vip_card || !userData.user_paid_vip_card || userData.need_collect_info == 1 ? '.30rem': 0
                    }}>
                      <Carousel
                        dots={userData.user_vip_card && userData.user_paid_vip_card && userData.need_collect_info !=1 ? true: false}
                        style={{
                          height: userData.user_paid_vip_card && userData.need_collect_info !=1 ? 'calc('+transformPx2Rem(customFeature.topSectionStyle.topHeight, 320)+' + 20px)' : transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                          zIndex: 2
                        }}
                        dotStyle={{
                          background: '#E1E1E1'
                        }}
                        dotActiveStyle={{
                          background: '#ADADAD'
                        }}
                        >
                          {
                            [
                              !!(!userData.user_vip_card && !userData.user_paid_vip_card || userData.need_collect_info == 1) && (
                                <div className="personal-mode-3 show-view"
                                  style={{
                                    textAlign: 'center',
                                    height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                                    backgroundColor: customFeature.topSectionStyle['background-color'],
                                    backgroundImage: customFeature.topSectionStyle['background-image'],
                                    opacity: customFeature.topSectionStyle['opacity'] || 1,
                                    backgroundSize: '100% 100%',
                                  }}
                                  onClick={this.vipCardTurnToPage}
                                  data-type="average-user"
                                  data-needcollectinfo={userData.need_collect_info}
                                  data-isturnto={userData.all_vip_card.length>0 || userData.is_vip_benefit_day == 1 ? 'true' : 'false'}
                                >
                                  {((!data.customFeature.topSectionStyle['background-image'] && !userData.user_paid_vip_card && !userData.user_vip_card) || (!userData.user_paid_vip_card && userData.user_vip_card && userData.user_vip_card.background_type == 1) || (userData.user_paid_vip_card && userData.user_paid_vip_card.background_type == 1)) && <img className="user-center-mark" src="https://cdn.jisuapp.cn/static/jisuapp_editor/images/userCenterHead.png" />}
                                  <div className="personal-main">
                                    <img className="cover-thumb" style={{
                                        width: customFeature.topSectionStyle.coverHeight,
                                        height: customFeature.topSectionStyle.coverHeight,
                                      }} src={userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'}
                                      onClick={this.userCenterTurnToPage} data-router="userCenter" alt=""/>
                                    <div className="personal-main-right">
                                      <div className="nickname" style={{
                                        color: customFeature.topSectionStyle.color,
                                        fontSize: customFeature.topSectionStyle['font-size'],
                                        fontStyle: customFeature.topSectionStyle['font-style'],
                                        textDecoration: customFeature.topSectionStyle['text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['font-weight'],
                                      }}>{userInfo.nickname || '用户名'}</div>
                                      <div className="user-type" style={{
                                        color: customFeature.topSectionStyle['vip-color'],
                                        fontSize: customFeature.topSectionStyle['vip-font-size'],
                                        fontStyle: customFeature.topSectionStyle['vip-font-style'],
                                        textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['vip-font-weigh'],
                                      }}>普通用户</div>
                                    </div>
                                  </div>
                                  {
                                    userData.buyVip == true && userData.need_collect_info == 0 && (<div className="buy-vip-hot buy-vip-margin"
                                      onClick={this.vipCardTurnToPage} data-type="buy-vip" data-id="''">
                                      <div className="buy-vip" style={{
                                        color: customFeature.topSectionStyle['button-color'],
                                        fontSize: customFeature.topSectionStyle['button-font-size'],
                                        fontStyle: customFeature.topSectionStyle['button-font-style'],
                                        textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                        background: customFeature['button-background'],
                                      }}>购买会员</div>
                                    </div>)
                                  }
                                  {
                                    userData.need_collect_info == 1 && (
                                      <div className="buy-vip-hot get-vip" onClick={this.vipCardTurnToPage} data-type="get-vip" data-id={userData.user_vip_card && userData.user_vip_card.vip_id}>
                                        <div className="buy-vip" style={{
                                          color: customFeature.topSectionStyle['button-color'],
                                          fontSize: customFeature.topSectionStyle['button-font-size'],
                                          fontStyle: customFeature.topSectionStyle['button-font-style'],
                                          textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                          fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                          background: customFeature['button-background'],
                                        }}>{userData.reminder_config.button}</div>
                                      </div>
                                    )
                                  }
                                  {
                                    userData.need_collect_info == 1 && (
                                      <div className="vip-bottom-font" onClick={this.vipCardTurnToPage} data-type="get-vip">
                                        <span style={{
                                          color: customFeature.topSectionStyle['other-color'],
                                          fontSize: customFeature.topSectionStyle['other-font-size'],
                                          fontStyle: customFeature.topSectionStyle['other-font-style'],
                                          textDecoration: customFeature.topSectionStyle['other-text-decoration'],
                                          fontWeight: customFeature.topSectionStyle['other-font-weight'],
                                        }}>{userData.reminder_config.description}</span>
                                      </div>
                                    )
                                  }
                                </div>
                              ),
                              !!(userData.user_paid_vip_card && userData.need_collect_info != 1) && (
                                <div className="personal-mode-3 show-view"
                                  style={{
                                    textAlign: 'center',
                                    height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                                    backgroundColor: customFeature.topSectionStyle['background-color'],
                                    backgroundImage: customFeature.topSectionStyle['background-image'],
                                    opacity: customFeature.topSectionStyle['opacity'] || 1,
                                    backgroundSize: '100% 100%',
                                  }}
                                  onClick={this.vipCardTurnToPage}
                                  data-type="renewal-vip"
                                  data-id={userData.user_paid_vip_card.vip_id}
                                >
                                  {((!data.customFeature.topSectionStyle['background-image'] && !userData.user_paid_vip_card && !userData.user_vip_card) || (!userData.user_paid_vip_card && userData.user_vip_card && userData.user_vip_card.background_type == 1) || (userData.user_paid_vip_card && userData.user_paid_vip_card.background_type == 1)) && <img className="user-center-mark" src="https://cdn.jisuapp.cn/static/jisuapp_editor/images/userCenterHead.png" />}
                                  <div className="personal-main">
                                    <img className="cover-thumb" style={{
                                        width: customFeature.topSectionStyle.coverHeight,
                                        height: customFeature.topSectionStyle.coverHeight,
                                        zIndex: 2,
                                      }} src={userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'}
                                      onClick={this.userCenterTurnToPage} data-router="userCenter" alt=""/>
                                    <div className="personal-main-right">
                                      <div className="nickname" style={{
                                        color: customFeature.topSectionStyle.color,
                                        fontSize: customFeature.topSectionStyle['font-size'],
                                        fontStyle: customFeature.topSectionStyle['font-style'],
                                        textDecoration: customFeature.topSectionStyle['text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['font-weight'],
                                      }}>{userInfo.nickname || '用户名'}</div>
                                      <div className="user-type pay-user-type" style={{
                                        color: customFeature.topSectionStyle['vip-color'],
                                        fontSize: customFeature.topSectionStyle['vip-font-size'],
                                        fontStyle: customFeature.topSectionStyle['vip-font-style'],
                                        textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['vip-font-weigh'],
                                      }}>{userData.user_paid_vip_card.title}</div>
                                    </div>
                                  </div>
                                  <div className="ico-moon icon-qr-code qr-code" onClick={this.showQRRemark} data-compindex={this.props.index} data-id={userData.user_paid_vip_card} data-type="1" data-isshow="true"></div>
                                  <div className="buy-vip-hot">
                                    {userData.user_paid_vip_card.enable_status == 1 && (<div className="buy-vip renewal-vip" onClick={this.vipCardTurnToPage} data-type="renewal-vip" data-id={userData.user_paid_vip_card && userData.user_paid_vip_card.vip_id}
                                      style={{
                                        color: customFeature.topSectionStyle['button-color'],
                                        fontSize: customFeature.topSectionStyle['button-font-size'],
                                        fontStyle: customFeature.topSectionStyle['button-font-style'],
                                        textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                        background: customFeature['button-background'],
                                      }}>立即续费</div>
                                    )}
                                    <div className="vip-bottom-date"
                                      style={{
                                        color: customFeature.topSectionStyle['other-color'],
                                        fontSize: customFeature.topSectionStyle['other-font-size'],
                                        fontStyle: customFeature.topSectionStyle['other-font-style'],
                                        textDecoration: customFeature.topSectionStyle['other-text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['other-font-weight'],
                                      }}>
                                      {
                                        userData.user_paid_vip_card.is_show_vipid == 1 && (
                                          <div className="vip-id">N0.{userData.user_paid_vip_card.id}</div>
                                        )
                                      }
                                      <div className="vip-expired-time">
                                        {
                                          userData.user_paid_vip_card.expired_time != '永久' ? 
                                          <span>{userData.user_paid_vip_card.expired_time}到期</span>
                                          :
                                          <span>{userData.user_paid_vip_card.expired_time}有效</span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ),
                              !!(userData.user_vip_card && userData.need_collect_info != 1) && (
                                <div className="personal-mode-3 show-view"
                                  style={{
                                    textAlign: 'center',
                                    height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                                    backgroundColor: userData.user_vip_card.background_type == 1 ? userData.user_vip_card.background : '',
                                    backgroundImage: userData.user_vip_card.background_type  == 0 ? 'url('+userData.user_vip_card.background+')' : '',
                                    opacity: customFeature.topSectionStyle['opacity'] || 1,
                                    backgroundSize: '100% 100%',
                                  }}
                                  onClick={this.vipCardTurnToPage} data-type="ordinary-vip" data-id={ userData.user_vip_card.vip_id} >
                                  {
                                    ((!data.customFeature.topSectionStyle['background-image'] && !userData.user_paid_vip_card && !userData.user_vip_card) || (!userData.user_paid_vip_card && userData.user_vip_card && userData.user_vip_card.background_type == 1) || (userData.user_paid_vip_card && userData.user_paid_vip_card.background_type == 1)) && (
                                      <img className="user-center-mark" src="https://cdn.jisuapp.cn/static/jisuapp_editor/images/userCenterHead.png" />
                                    )
                                  }
                                  <div className="personal-main">
                                    <img className="cover-thumb" style={{
                                        width: customFeature.topSectionStyle.coverHeight,
                                        height: customFeature.topSectionStyle.coverHeight,
                                        zIndex: 2
                                      }}
                                      src={ userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'} onClick={this.userCenterTurnToPage} data-router="userCenter" />
                                    <div className="personal-main-right">
                                      <div className="nickname" style={{
                                        color: customFeature.topSectionStyle.color,
                                        fontSize: customFeature.topSectionStyle['font-size'],
                                        fontStyle: customFeature.topSectionStyle['font-style'],
                                        textDecoration: customFeature.topSectionStyle['text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['font-weight'],
                                      }}>{ userInfo.nickname || '用户名' }</div>
                                      <div className='user-type' style={{
                                        color: customFeature.topSectionStyle['vip-color'],
                                        fontSize: customFeature.topSectionStyle['vip-font-size'],
                                        fontStyle: customFeature.topSectionStyle['vip-font-style'],
                                        textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['vip-font-weigh'],
                                      }}>{userData.user_vip_card.title}</div>
                                    </div>
                                  </div>
                                  <div className="ico-moon icon-qr-code qr-code" onClick={this.showQRRemark} data-compindex={this.props.index} data-id={userData.user_vip_card.id} data-type="0" data-isshow="true"></div>
                                  {
                                    userData.buyVip==true && (
                                      <div className="buy-vip-hot" onClick={this.vipCardTurnToPage} data-type="buy-vip" data-id="''" >
                                        <div className="buy-vip buy-vip-margin-2"
                                          style={{
                                            color: customFeature.topSectionStyle['button-color'],
                                            fontSize: customFeature.topSectionStyle['button-font-size'],
                                            fontStyle: customFeature.topSectionStyle['button-font-style'],
                                            textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                            fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                            background: customFeature['button-background'],
                                          }}>购买会员</div>
                                      </div>
                                    )
                                  }
                                  <div className="vip-bottom-date" 
                                    style={{
                                      color: customFeature.topSectionStyle['other-color'],
                                        fontSize: customFeature.topSectionStyle['other-font-size'],
                                        fontStyle: customFeature.topSectionStyle['other-font-style'],
                                        textDecoration: customFeature.topSectionStyle['other-text-decoration'],
                                        fontWeight: customFeature.topSectionStyle['other-font-weight'],
                                    }}>
                                    {
                                      userData.user_vip_card.is_show_vipid == 1 && (
                                        <div className="vip-id">N0.{userData.user_vip_card.id}</div>
                                      )
                                    }
                                    <div className="vip-expired-time">
                                      {
                                        userData.user_vip_card.expired_time != '永久' ? 
                                        <span>{userData.user_vip_card.expired_time}到期</span>
                                        :
                                        <span>{userData.user_vip_card.expired_time}有效</span>
                                      }
                                    </div>
                                  </div>
                                </div>
                              ),
                            ].filter(Boolean).map((item, index) => <div key={index}>{item}</div>)
                          }
                      </Carousel>
                    </div>
                  </div>
                )
              }
              {
                customFeature['senior-mode'] == 2 && (
                  <div className="senior-mode" style={{
                    textAlign: 'center',
                    height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                    backgroundColor: customFeature.topSectionStyle['background-color'],
                    backgroundImage: customFeature.topSectionStyle['background-image'],
                    opacity: customFeature.topSectionStyle['opacity'] || 1,
                    backgroundSize: '100% 100%',
                  }}>
                    <div className="senior-mode-user" onClick={this.userCenterTurnToPage} data-router="userCenter">
                      <img className="cover-thumb" style={{
                        width: customFeature.topSectionStyle.coverHeight,
                        height: customFeature.topSectionStyle.coverHeight,
                      }} src={userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt=""/>
                      <label className="nickname" style={{
                        color: customFeature.topSectionStyle.color,
                        fontSize: customFeature.topSectionStyle['font-size'],
                        fontStyle: customFeature.topSectionStyle['font-style'],
                        textDecoration: customFeature.topSectionStyle['text-decoration'],
                        fontWeight: customFeature.topSectionStyle['font-weight'],
                        marginLeft: '.20rem'
                      }}>{ userInfo.nickname || '用户名' }</label>
                      <label className="ico-moon icon-rightarrow"></label>
                    </div>
                    <div className="member-card-box" onClick={this.vipCardTurnToPage} data-type="average-user" data-needcollectinfo={userData.need_collect_info} data-isturnto={userData.all_vip_card.length > 0 || userData.is_vip_benefit_day == 1?'true':'false'}>
                      <div style={{
                        height: data.customFeature.showInfo ? '2.36rem':'.86rem',
                        transition: 'all linear 0.25s',
                        overflow: 'hidden',
                      }}>
                        <Carousel
                          dots={userData.user_vip_card && userData.user_paid_vip_card && userData.need_collect_info !=1 ? true:false}
                          dotStyle={{
                            background: '#B2B2B2'
                          }}
                          dotActiveStyle={{
                            background: '#E5E5E5'
                          }}
                          >
                          {
                            [
                              // 无卡用户
                              !!(!userData.user_vip_card && !userData.user_paid_vip_card || userData.need_collect_info == 1) && (
                                <div className="senior-mode-card">
                                  <div className='card-head none-card'>
                                    <img src='http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_close.png' mode="aspectFill" className='card-head-ico'></img>
                                    {
                                      userData.need_collect_info == 0 && <span>暂无会员卡</span>
                                    }
                                    {
                                      userData.need_collect_info == 1 && <span onClick={this.vipCardTurnToPage} data-type="get-vip">{userData.reminder_config.description}</span>
                                    }
                                    <div className='card-head-btn'>
                                      {
                                        (userData.buyVip && userData.need_collect_info == 0) && 
                                        <div onClick={this.vipCardTurnToPage} data-type="buy-vip" data-id="''" >购买会员</div>
                                      }
                                      {
                                        (userData.need_collect_info == 1) &&
                                        <div onClick={vipCardTurnToPage} data-type="get-vip" data-id={userData.user_vip_card && userData.user_vip_card.vip_id}>{userData.reminder_config.button}</div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              ),
                              // 付费卡
                              !!(userData.user_paid_vip_card && userData.need_collect_info != 1) && (
                                <div className="senior-mode-card">
                                  <div className='card-head'>
                                    <img src='http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png' mode="aspectFill" className='card-head-ico'/>
                                    <span className='card-head-title' style={{color:'#4a3d34'}}>{userData.user_paid_vip_card.title}</span>
                                    <div className='card-head-btn' onClick={this.showVipCardInfo} data-compindex={this.props.index} data-show={data.customFeature.showInfo}>
                                      {
                                        !data.customFeature.showInfo ?
                                        <span>展开</span>
                                        :
                                        <span>收起</span>
                                      }
                                      <label className={`ico-moon icon-${data.customFeature.showInfo? 'up' : 'down'}arrow`}></label>
                                    </div>
                                  </div>
                                  <div className='card-main'>
                                    {
                                      userData.user_paid_vip_card.is_show_vipid == 1 &&
                                      <span className='card-number'>N0.{userData.user_paid_vip_card.id}</span>
                                    }
                                    {
                                      userData.user_paid_vip_card.enable_status == 1 &&
                                      <div className="card-buyVip"
                                        onClick={this.vipCardTurnToPage} data-type="renewal-vip"
                                        data-id={userData.user_paid_vip_card && userData.user_paid_vip_card.vip_id}
                                        style={{
                                          color: customFeature.topSectionStyle['button-color'],
                                          fontSize: customFeature.topSectionStyle['button-font-size'],
                                          fontStyle: customFeature.topSectionStyle['button-font-style'],
                                          textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                          fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                          background: customFeature['button-background'],
                                        }}
                                        >立即续费</div>
                                    }
                                    <div className='card-qrcode'>
                                      {
                                        userData.user_paid_vip_card.expired_time != '永久' ?
                                          <span>{userData.user_paid_vip_card.expired_time}到期</span>
                                          :
                                          <span>{userData.user_paid_vip_card.expired_time}有效</span>
                                      }
                                      <span className='ico-moon icon-qr-code' onClick={this.showQRRemark} data-compindex={this.props.index} data-id={userData.user_paid_vip_card.id} data-type="1" data-isshow="true"></span>
                                    </div>
                                  </div>
                                </div>
                              ),
                              // 免费卡
                              !!(userData.user_vip_card && userData.need_collect_info != 1) && (
                                <div className="senior-mode-card">
                                  <div className='card-head'>
                                    <img src='http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png' mode="aspectFill" className='card-head-ico' />
                                    <span className='card-head-title' style={{color:'#4a3d34'}}>{userData.user_vip_card.title}</span>
                                    <div className='card-head-btn' onClick={this.showVipCardInfo} data-compindex={this.props.index} data-show={data.customFeature.showInfo}>
                                      {
                                        !data.customFeature.showInfo ?
                                        <span>展开</span>
                                        :
                                        <span>收起</span>
                                      }
                                      <label className={`ico-moon icon-${data.customFeature.showInfo? 'up' : 'down'}arrow`}></label>
                                    </div>
                                  </div>
                                  <div className='card-main'>
                                    {
                                      userData.user_vip_card.is_show_vipid == 1 &&
                                      <span className='card-number'>N0.{userData.user_vip_card.id}</span>
                                    }
                                    {
                                      userData.buyVip == true &&
                                      <div className="card-buyVip"
                                        onClick={this.vipCardTurnToPage} data-type="buy-vip"
                                        style={{
                                          color: customFeature.topSectionStyle['button-color'],
                                          fontSize: customFeature.topSectionStyle['button-font-size'],
                                          fontStyle: customFeature.topSectionStyle['button-font-style'],
                                          textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                          fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                          background: customFeature['button-background'],
                                        }}
                                        >立即购买</div>
                                    }
                                    <div className='card-qrcode'>
                                      {
                                        userData.user_vip_card.expired_time != '永久' ?
                                          <span>{userData.user_vip_card.expired_time}到期</span>
                                          :
                                          <span>{userData.user_vip_card.expired_time}有效</span>
                                      }
                                      <span className='ico-moon icon-qr-code' onClick={this.showQRRemark} data-compindex={this.props.index} data-id={data.userData.user_vip_card.id} data-type="0" data-isshow="true"></span>
                                    </div>
                                  </div>
                                </div>
                              ),
                            ].filter(Boolean).map((item, index) => <div key={index}>{item}</div>)
                          }
                        </Carousel>
                      </div>
                    </div>
                  </div>
                )
              }
              {
                customFeature['senior-mode'] == 3 && (
                  <div style={{backgroundColor: '#fff'}}>
                    <div className={`senior-mode ${customFeature.showInfo ? '' : 'bottom-radius'} senior-mode-3`} style={{
                      textAlign: 'center',
                      height: transformPx2Rem(customFeature.topSectionStyle.topHeight, 320),
                      backgroundColor: customFeature.topSectionStyle['background-color'],
                      backgroundImage: customFeature.topSectionStyle['background-image'],
                      opacity: customFeature.topSectionStyle['opacity'] || 1,
                      backgroundSize: '100% 100%',
                    }}>
                      <div className="senior-mode-user" onClick={this.userCenterTurnToPage} data-router="userCenter">
                        <img className="cover-thumb" style={{
                          width: customFeature.topSectionStyle.coverHeight,
                          height: customFeature.topSectionStyle.coverHeight,
                        }} src={userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt=""/>
                        <div style={{
                          textAlign: 'left'
                        }}>
                          <label className="nickname" style={{
                            color: customFeature.topSectionStyle.color,
                            fontSize: customFeature.topSectionStyle['font-size'],
                            fontStyle: customFeature.topSectionStyle['font-style'],
                            textDecoration: customFeature.topSectionStyle['text-decoration'],
                            fontWeight: customFeature.topSectionStyle['font-weight'],
                            marginLeft: '.20rem',
                          }}>{ userInfo.nickname || '用户名' }</label>
                          <div className="default-user" style={{
                            color: customFeature.topSectionStyle['vip-color'],
                            fontSize: customFeature.topSectionStyle['vip-font-size'],
                            fontStyle: customFeature.topSectionStyle['vip-font-style'],
                            textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                            fontWeight: customFeature.topSectionStyle['vip-font-weight'],
                          }}>{userData.user_paid_vip_card ? '恭喜您，您已经是我们的付费会员' : userData.user_vip_card ? '恭喜您，您已经是我们的普通会员': '普通用户' }</div>
                        </div>
                      </div>
                      <div className="member-card-box"
                        onClick={this.vipCardTurnToPage}
                        data-type="average-user"
                        data-needcollectinfo={userData.need_collect_info}
                        data-isturnto={userData.all_vip_card.length > 0 || userData.is_vip_benefit_day == 1?'true':'false'}
                        >
                          <div className={`${data.customFeature.showInfo ? "" : "senior-mode-radius"}`}>
                            <Carousel
                              dots={userData.user_vip_card && userData.user_paid_vip_card && userData.need_collect_info !=1 ? true:false}
                              style={{
                                height: data.customFeature.showInfo ? '2.36rem':'.86rem',
                                transition: 'all linear 0.25s',
                              }}
                              dotStyle={{
                                background: '#B2B2B2'
                              }}
                              dotActiveStyle={{
                                background: '#E5E5E5'
                              }}
                              >
                              {
                                [
                                  // 无卡用户
                                  !!(!data.userData.user_vip_card && !data.userData.user_paid_vip_card || data.userData.need_collect_info == 1) && (
                                    <div className='senior-mode-card senior-mode-card2'>
                                      <div className='card-head none-card'>
                                        <img src='http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_close.png' mode="aspectFill" className='card-head-ico'/>
                                        {
                                          userData.need_collect_info == 0 &&
                                          <span>暂无会员卡</span>
                                        }
                                        {
                                          userData.need_collect_info == 1 &&
                                          <span onClick={this.vipCardTurnToPage} data-type="get-vip">{userData.reminder_config.description}</span>
                                        }
                                        <div className='card-head-btn'>
                                          {
                                            userData.buyVip && userData.need_collect_info == 0 && (
                                              <div onClick={this.vipCardTurnToPage} data-type="buy-vip" data-id="''" >购买会员</div>
                                            )
                                          }
                                          {
                                            userData.need_collect_info == 1 && 
                                            <div onClick={this.vipCardTurnToPage} data-type="get-vip" data-id={data.userData.user_vip_card && data.userData.user_vip_card.vip_id} >{data.userData.reminder_config.button}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                  // 付费卡
                                  !!(data.userData.user_paid_vip_card && data.userData.need_collect_info != 1) && (
                                    <div className='senior-mode-card  senior-mode-card2'>
                                      <div className='card-head'>
                                        <img src='http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png' mode="aspectFill" className='card-head-ico'/>
                                        <span className='card-head-title' style="color:#DAAF87">{data.userData.user_paid_vip_card.title}</span>
                                        <div className='card-head-btn' onClick={this.showVipCardInfo} data-compindex={this.props.index} data-show={data.customFeature.showInfo}>
                                          {
                                            !data.customFeature.showInfo ?
                                            <span>展开</span>
                                            :
                                            <span>收起</span>
                                          }
                                          <label className={`ico-moon icon-${data.customFeature.showInfo? 'up' : 'down'}arrow`}></label>
                                        </div>
                                      </div>
                                      <div className='card-main'>
                                        {
                                          userData.user_paid_vip_card.is_show_vipid == 1 &&
                                          <span className='card-number'>N0.{userData.user_paid_vip_card.id}</span>
                                        }
                                        {
                                          userData.user_paid_vip_card.enable_status == 1 &&
                                          <div className="card-buyVip"
                                            onClick={this.vipCardTurnToPage} data-type="renewal-vip"
                                            data-id={userData.user_paid_vip_card && userData.user_paid_vip_card.vip_id}
                                            style={{
                                              color: customFeature.topSectionStyle['button-color'],
                                              fontSize: customFeature.topSectionStyle['button-font-size'],
                                              fontStyle: customFeature.topSectionStyle['button-font-style'],
                                              textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                              fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                              background: customFeature['button-background'],
                                            }}
                                            >立即续费</div>
                                        }
                                        <div className='card-qrcode'>
                                          {
                                            userData.user_paid_vip_card.expired_time != '永久' ?
                                              <span>{userData.user_paid_vip_card.expired_time}到期</span>
                                              :
                                              <span>{userData.user_paid_vip_card.expired_time}有效</span>
                                          }
                                          <span className='ico-moon icon-qr-code' onClick={this.showQRRemark} data-compindex={this.props.index} data-id={userData.user_paid_vip_card.id} data-type="1" data-isshow="true"></span>
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                  // 免费卡
                                  !!(data.userData.user_vip_card && data.userData.need_collect_info != 1) && (
                                    <div className='senior-mode-card senior-mode-card2'>
                                      <div className='card-head'>
                                        <img src='http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png' mode="aspectFill" className='card-head-ico'/>
                                        <span className='card-head-title'  style={{color:'#DAAF87'}}>{data.userData.user_vip_card.title}</span>
                                        <div className='card-head-btn' onClick={this.showVipCardInfo} data-compindex={this.props.index} data-show={data.customFeature.showInfo}>
                                          {
                                            !data.customFeature.showInfo ?
                                            <span>展开</span>
                                            :
                                            <span>收起</span>
                                          }
                                          <label className={`ico-moon icon-${data.customFeature.showInfo? 'up' : 'down'}arrow`}></label>
                                        </div>
                                      </div>
                                      <div className='card-main'>
                                        {
                                          userData.user_vip_card.is_show_vipid == 1 &&
                                          <span className='card-number'>N0.{userData.user_vip_card.id}</span>
                                        }
                                        {
                                          userData.buyVip == true &&
                                          <div className="card-buyVip"
                                            onClick={this.vipCardTurnToPage} data-type="buy-vip"
                                            style={{
                                              color: customFeature.topSectionStyle['button-color'],
                                              fontSize: customFeature.topSectionStyle['button-font-size'],
                                              fontStyle: customFeature.topSectionStyle['button-font-style'],
                                              textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                                              fontWeight: customFeature.topSectionStyle['button-font-weight'],
                                              background: customFeature['button-background'],
                                            }}
                                            >立即购买</div>
                                        }
                                        <div className='card-qrcode'>
                                          {
                                            userData.user_vip_card.expired_time != '永久' ?
                                              <span>{userData.user_vip_card.expired_time}到期</span>
                                              :
                                              <span>{userData.user_vip_card.expired_time}有效</span>
                                          }
                                          <span className='ico-moon icon-qr-code' onClick={this.showQRRemark} data-compindex={this.props.index} data-id={data.userData.user_vip_card.id} data-type="0" data-isshow="true"></span>
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                ].filter(Boolean).map((item, index) => <div key={index}>{item}</div>)
                              }
                            </Carousel>
                          </div>
                      </div>
                    </div> 
                  </div>
                )
              }
            </React.Fragment>
          )
        }
        {
          customFeature.isHiddenComponent && customFeature['member'] == 2 && customFeature['senior-mode'] != 1 && (
            <div style={{
              height: '.8rem',
              background: '#fff',
            }}></div>
          )
        }
        {
          userData && !customFeature.isHiddenComponent &&
          <React.Fragment>
            <div style={{
              height: transformPx2Rem(customFeature['margin-top'], 320),
              background: '#fff'
            }}></div>
            <div
              className="user-data-show"
              style={{
                height: transformPx2Rem(customFeature.height, 320)
              }}>
              {
                customFeature.showDataBlock && customFeature.showDataBlock[0].blockArr.map((item, index) => 
                  <div
                    key={index}
                    className="user-data-show-item"
                    style={{
                      width: `calc(100% / ${customFeature.colums})`
                    }}
                    onClick={this[item.bindtap]}
                    data-router={item.router}
                  >
                    <div style={{
                      width: '100%',
                    }}>
                      <div style={{
                        color: '#686868',
                        fontSize: '.36rem',
                        fontWeight: 'bold',
                      }}>{userData[item.feild]}
                        { userData.cross_add_coupon_mark >0 && item.feild == 'coupon_count' && (
                          <span className="coupon-prompt"></span>
                        )}
                        { item.feild == 'coupon_count' && (
                          <span>张</span>
                        )}
                        { item.feild == 'balance' && (
                          <span>元</span>
                        )}
                      </div>
                      <div style={{
                        color: '#999999',
                        fontSize: '.24rem'
                      }}>{item.name}</div>
                    </div>
                    {
                      index != customFeature.showDataBlock[0].blockArr.length - 1 && (
                        <div className="user-data-divline">
                          <div className='divline-content'></div>
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div>
          </React.Fragment>
        }
        {
          userData && customFeature.isShowIntegral && !!userData.xcx_differential_entry && (
            <div className="integral-platform" onClick={this.vipCardTurnToPage} data-type="differential-mall">
              <div className="ico-moon icon-differential-tag icon-container-cover icon-differentail-color"></div>
              <span className="integral-platform-title">微分商城</span>
              <span className="integral-platform-content">海量商家优惠券等你去领！</span>
              <div className="integral-platform-right">
                {
                  userData.cross_add_differential_mark > 0 && (
                    <span className="integral-platform-prompt"></span>
                  )
                }
                <div className="ico-moon icon-rightarrow icon-container-cover"></div>
              </div>
            </div>
          )
        }
        {
          userData && data.qrData && userData.qrRemarkShow && (
            <div className="qr-remark" onClick={this.showQRRemark} data-compindex={this.props.index} data-isshow="false">
              <div className="paid-vip-info" onClick={this.showQRRemark}>
                <div className="paid-vip-title">
                  <span>{data.qrData.user_info}</span>
                </div>
                <div className="paid-vip-content">
                  <img src={data.qrData.pic_url} className="paid-vip-card-qr"/>
                  <div className="paid-vip-card-id">{data.qrData.id}</div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    );
        
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/user-center-head-custom-component/UserCenterHeadCustomComponent.jsx